<template>
    <div class="mb-6">

        <v-row>
            <v-col cols="12" md="5">
                <v-form @submit.prevent="register" ref="refRegister" lazy-validation>
                    <v-card :loading="loading">
                        <v-card-title>
                            {{ $t('Nueva red social') }}
                        </v-card-title>
                        <v-card-text>

                            <v-select
                                :items="itemsRrss"
                                v-model="data.rrss"
                                :label="$t('Red social')"
                                dense
                                outlined
                                :disabled="loading"
                                :rules="[rules.required]"
                            >
                                <template v-slot:item="{item}">
                                    <div>
                                        {{item.name}}
                                    </div>
                                </template>
                                <template v-slot:selection="{item}">
                                    <div>
                                        {{item.name}}
                                    </div>
                                </template>
                            </v-select>
                            <v-text-field
                                :label="$t('URL de la red social')"
                                v-model="data.url"
                                outlined
                                dense
                                type="url"
                                :disabled="loading"
                                :rules="[rules.required, rules.url]"
                            ></v-text-field>

                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                                outlined
                                color="error"
                                :disabled="loading"
                                @click="clearData"
                            >{{ $t('Cancelar') }}</v-btn>
                            <v-btn
                                type="submit"
                                color="primary"
                                :loading="loading"
                            >{{ $t('Registrar') }}</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-form>
            </v-col>
            <v-col cols="12" md="7">
                <v-card>
                    <v-card-title class="blue-grey darken-4 white--text">
                        {{ $t('Redes sociales') }}
                    </v-card-title>

                    <v-card-text>
                        <v-simple-table>
                            <template v-slot:default>
                            <thead>
                                <tr>
                                    <th class="text-left text-uppercase">
                                        {{ $t('Red social') }}
                                    </th>
                                    <th class="text-left text-uppercase">
                                        {{ $t('Url') }}
                                    </th>
                                    <th class="text-right text-uppercase">
                                        {{ $t('Acciones') }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in dataSocialNetworks" :key="index">
                                    <td>{{ item.name }}</td>
                                    <td>{{ item.url }}</td>
                                    <td class="text-right">
                                        <div class="d-flex justify-end">
                                            <!-- <v-tooltip top>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        icon
                                                        @click="editUser(item.id)"
                                                    >
                                                        <v-icon color="grey">
                                                            mdi-pencil
                                                        </v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Editar</span>
                                            </v-tooltip> -->

                                            <v-tooltip top>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        icon
                                                        @click="deleteSocialNetworks(item.id)"
                                                    >
                                                        <v-icon color="grey">
                                                            mdi-delete
                                                        </v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>{{ $t('Eliminar') }}</span>
                                            </v-tooltip>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                            </template>
                        </v-simple-table>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <!-- overlay -->
        <v-overlay :value="overlay" opacity=".9" z-index="10">
            <v-progress-circular
                indeterminate
                size="64"
                color="primary"
            ></v-progress-circular>
        </v-overlay>
        <!-- end overlay -->

    </div>
</template>
<script>
export default {
    data() {
        return {
            overlay: false,
            loading: false,
            itemsRrss: [
                { name: 'Facebook', icon: 'mdi-facebook' },
                { name: 'Instagram', icon: 'mdi-instagram' },
                { name: 'Twitter', icon: 'mdi-twitter' },
                { name: 'YouTube', icon: 'mdi-youtube' },
                { name: 'Linkedin', icon: 'mdi-linkedin' },
                { name: 'Whatsapp', icon: 'mdi-whatsapp' },
                { name: 'Email', icon: 'mdi-email' },
                { name: 'TikTok', icon: 'mdi-music-note-outline' },
                { name: 'Otro', icon: 'mdi-web' },
            ],
            data: {
                rrss: null,
                url: '',
            },
            dataSocialNetworks: [],
            // validation
            rules: {
                required: v => !!v || 'El campo es obligatorio',
                url: v => /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/.test(v) || 'URL inválida',
            },
            errors: {}
        }
    },
    props: ['slug'],
    mounted() {
        this.getSocialNetworks();
    },
    methods: {
        // end banner
        clearData() {
            this.data = {
                rrss: null,
                url: '',
            }
        },
        /**
         * lista de banners
         */
        async getSocialNetworks() {
            this.overlay = true
            this.dataSocialNetworks = []
            await axios.get(`/get-rrss/${this.slug}`)
            .then((response) => {
                // console.log(response);
                response.data.forEach(element => {
                    let content = JSON.parse(element.content)
                    content.id = element.id
                    this.dataSocialNetworks.push(content)
                });
                this.overlay = false
            })
            .catch((error) => {
                if (error.response.data.errors) {
                    this.errors = error.response.data.errors
                }
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert(this.$t('Error con el servidor, por favor vuelva a intentarlo más tarde.'));
                }
                this.overlay = false
            })
        },
        /**
         * Register new banner
         */
        async register() {
            if (this.$refs.refRegister.validate()) {
                this.errors = {}
                this.loading = true
                const formData = new FormData
                formData.append('rrss_name', this.data?.rrss?.name)
                formData.append('rrss_icon', this.data?.rrss?.icon)
                formData.append('rrss_url', this.data?.url)
                formData.append('slug', this.slug)
                await axios.post('/admin/new-rrss', formData)
                .then(response => {
                    // console.log(response);
                    if (response.data == 'ok') {
                        this.$notify.success(this.$t('Red social registrado correctamente.'));
                        this.getSocialNetworks()
                        this.clearData()
                        this.$refs.refRegister.reset()
                    }
                    this.loading = false
                })
                .catch(error => {
                    // console.log(error);
                    if (error.response.data.errors) {
                        this.errors = error.response.data.errors
                    }
                    if (error.response.status == 404 || error.response.status == 500) {
                        this.$alert(this.$t('Error con el servidor, por favor vuelva a intentarlo más tarde.'));
                    }
                    this.loading = false
                })
            }
        },

        /**
         * Delete
         */
        deleteSocialNetworks (id) {
            this.$confirm(
                this.$t('Se eliminará permanentemente del sistema'),
                this.$t('¿Eliminar red social?'),
                'info', {
                showCloseButton: true,
                reverseButtons: true,
                confirmButtonText: this.$t('Continuar'),
                cancelButtonText: this.$t('Cancelar'),
            }).then(res => {
                if (res) {
                    axios.delete(`/admin/del-rrss/${id}`)
                    .then(response => {
                        // console.log(response);
                        if (response.data == 'ok') {
                            this.$notify.success(this.$t('Red social eliminado correctamente.'));
                            this.getSocialNetworks()
                        }
                    })
                    .catch(error => {
                        // console.log(error)
                        if (error.response.status == 404 || error.response.status == 500) {
                            this.$alert(this.$t('Error con el servidor, por favor vuelva a intentarlo más tarde.'));
                        }
                    })
                }
            });
        },
    },
}
</script>
